module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', [(_vm.isLoading) ? _c('CustomLoader', {
    attrs: {
      "width": 70
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('b-card', {
    staticClass: "mainCardBG"
  }, [_c('b-card-text', [_c('b-navbar', {
    staticClass: "formCard",
    staticStyle: {
      "border-radius": "5px !important",
      "padding-left": "0px"
    },
    attrs: {
      "toggleable": "lg",
      "type": "dark",
      "variant": "primary"
    }
  }, [_c('b-navbar-nav', [_c('b-button', {
    attrs: {
      "size": "sm",
      "variant": "light"
    },
    on: {
      "click": _vm.previousSalesView
    }
  }, [_c('md-icon', {
    attrs: {
      "icon": "gear-fill",
      "aria-hidden": "true"
    }
  }, [_vm._v("skip_previous")]), _vm._v("Back\n          ")], 1)], 1), _vm._v(" "), _c('b-navbar-brand', {
    attrs: {
      "center": ""
    }
  }, [_vm._v("Freight WareHouse Execution\n          "), _c('small', {
    staticClass: "ml-2"
  }, [_c('b-badge', {
    attrs: {
      "variant": "info"
    }
  }, [_vm._v(_vm._s(_vm.ffExportDetail.portType == "Icd" ?
    " Stuffing At ICD" :
    " Stuffing At PORT (Port Stuffing)"))])], 1)])], 1), _vm._v(" "), _c('banner-component', {
    attrs: {
      "allModuleIdBanner": _vm.ALLMODULE,
      "jobSeriesBanner": _vm.JOBSERIES,
      "bannerClientName": _vm.mainEntryData.length > 0 ? _vm.mainEntryData[0].clientName : '',
      "iconId": "fa fa-ship"
    }
  }), _vm._v(" "), _c('b-card', {
    staticClass: "formCard"
  }, [_c('b-card-text', [(_vm.newContainerFlow == '1') ? _c('div', [_c('b-button', {
    staticClass: "pull-right",
    attrs: {
      "size": "sm",
      "variant": "dark"
    },
    on: {
      "click": _vm.showDocModal
    }
  }, [_vm._v("Upload Documents")]), _vm._v(" "), (_vm.ALLMODULE) ? _c('container-component', {
    attrs: {
      "allModuleIdContainer": _vm.ALLMODULE,
      "JOB": "FF"
    }
  }) : _vm._e()], 1) : _vm._e(), _vm._v(" "), _c('md-layout', {
    staticClass: "labelMargtop",
    attrs: {
      "gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "40"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("WareHouse Name")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "name": "nameOfCFS",
      "id": "nameOfCFS"
    },
    model: {
      value: (_vm.WarehouseStuffing.nameOfCFS),
      callback: function($$v) {
        _vm.$set(_vm.WarehouseStuffing, "nameOfCFS", $$v)
      },
      expression: "WarehouseStuffing.nameOfCFS"
    }
  })], 1), _vm._v(" "), (!_vm.WarehouseStuffing.nameOfCFS) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.nameOfCFSError))]) : _vm._e()], 1)], 1), _vm._v(" "), (_vm.newContainerFlow == '0') ? _c('div', [_c('div', [_c('div', {
    staticClass: "mt-3"
  }), _vm._v(" "), (_vm.getContainerList.length == 0) ? _c('md-layout', {
    staticClass: "gutr mt-4",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('b-button', {
    attrs: {
      "size": "sm",
      "variant": "outline-dark"
    },
    on: {
      "click": _vm.showMoreSBDet
    }
  }, [_vm._v(_vm._s(_vm.showMoreSB == true ? "Hide" : "Add") + " Shipping Bill\n                    Details")]), _vm._v(" "), _c('md-spinner', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "md-indeterminate": "",
      "id": "loader1"
    }
  }), _vm._v(" "), _c('b-button', {
    staticClass: "ml-2",
    attrs: {
      "size": "sm",
      "variant": "outline-dark"
    },
    on: {
      "click": _vm.showDocModal
    }
  }, [_vm._v("Upload SB Documents")])], 1)], 1) : _vm._e(), _vm._v(" "), (
    _vm.getContainerList.length > 0 ||
    _vm.SBDetail.shippingSBId != '' ||
    _vm.showMoreSB
  ) ? _c('b-card', {
    staticClass: "mt-3",
    staticStyle: {
      "background": "whiteSmoke"
    }
  }, [(
    _vm.getContainerList.length > 0 ||
    _vm.SBDetail.shippingSBId != '' ||
    _vm.showMoreSB
  ) ? _c('div', [_c('md-layout', {
    attrs: {
      "gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "25"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("Shipper Invoice No.")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "name": "shippingInvoiceNo",
      "id": "shippingInvoiceNo"
    },
    model: {
      value: (_vm.SBDetail.shippingInvoiceNo),
      callback: function($$v) {
        _vm.$set(_vm.SBDetail, "shippingInvoiceNo", $$v)
      },
      expression: "SBDetail.shippingInvoiceNo"
    }
  })], 1)], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "20"
    }
  }, [_c('label', [_vm._v("Invoice Date.")]), _vm._v(" "), _c('date-picker', {
    attrs: {
      "format": _vm.selectDateFormat,
      "lang": "en",
      "name": "shippingBillDate",
      "id": "shippingBillDate",
      "minute-step": 1
    },
    model: {
      value: (_vm.SBDetail.shippingInvoiceDate),
      callback: function($$v) {
        _vm.$set(_vm.SBDetail, "shippingInvoiceDate", $$v)
      },
      expression: "SBDetail.shippingInvoiceDate"
    }
  })], 1)], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-gutter": ""
    }
  }, [(_vm.viewInvoicedDoc.length > 0) ? _c('div', _vm._l((_vm.viewInvoicedDoc), function(item, index) {
    return _c('md-layout', {
      key: index,
      attrs: {
        "md-flex": "20"
      }
    }, [_c('a', {
      attrs: {
        "href": _vm.docURL + "/FF_Sea_Export_Uploads/" + item,
        "target": "_blank",
        "download": ""
      }
    }, [_vm._v("View Document - " + _vm._s(index + 1))])])
  })) : _vm._e()]), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-gutter": ""
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-gutter": ""
    }
  }, [(_vm.viewCargoDoc.length > 0) ? _c('div', _vm._l((_vm.viewCargoDoc), function(item, index) {
    return _c('md-layout', {
      key: index,
      attrs: {
        "md-flex": "30"
      }
    }, [_c('a', {
      attrs: {
        "href": _vm.docURL + "/FF_Sea_Export_Uploads/" + item,
        "target": "_blank",
        "download": ""
      }
    }, [_vm._v("View Document - " + _vm._s(index + 1))])])
  })) : _vm._e(), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "40"
    }
  }), _vm._v(" "), (_vm.viewShippingdDoc.length > 0) ? _c('div', _vm._l((_vm.viewShippingdDoc), function(item, index) {
    return _c('md-layout', {
      key: index,
      attrs: {
        "md-flex": "30"
      }
    }, [_c('a', {
      attrs: {
        "href": _vm.docURL + "/FF_Sea_Export_Uploads/" + item,
        "target": "_blank",
        "download": ""
      }
    }, [_vm._v("View Document - " + _vm._s(index + 1))])])
  })) : _vm._e()], 1), _vm._v(" "), _c('md-layout', {
    staticClass: "gutr",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "15"
    }
  }, [_c('label', [_vm._v("Shipping Bill Date *")]), _vm._v(" "), _c('date-picker', {
    attrs: {
      "format": _vm.selectDateFormat,
      "lang": "en",
      "name": "shippingBillDate",
      "id": "shippingBillDate",
      "minute-step": 1
    },
    model: {
      value: (_vm.SBDetail.shippingBillDate),
      callback: function($$v) {
        _vm.$set(_vm.SBDetail, "shippingBillDate", $$v)
      },
      expression: "SBDetail.shippingBillDate"
    }
  }), _vm._v(" "), (!_vm.SBDetail.shippingBillDate) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.errorSBExecution.shippingBillDate))]) : _vm._e()], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "40"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("Shipping Bill No. *")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "name": "shippingBillNo",
      "id": "shippingBillNo"
    },
    model: {
      value: (_vm.SBDetail.shippingBillNo),
      callback: function($$v) {
        _vm.$set(_vm.SBDetail, "shippingBillNo", $$v)
      },
      expression: "SBDetail.shippingBillNo"
    }
  })], 1), _vm._v(" "), (!_vm.SBDetail.shippingBillNo) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.errorSBExecution.shippingBillNo))]) : _vm._e()], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "35"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("Cargo Gross Weight(KGS) *")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "name": "cargoGrossWeight",
      "type": "number",
      "min": "0",
      "id": "cargoGrossWeight"
    },
    model: {
      value: (_vm.SBDetail.cargoGrossWeight),
      callback: function($$v) {
        _vm.$set(_vm.SBDetail, "cargoGrossWeight", $$v)
      },
      expression: "SBDetail.cargoGrossWeight"
    }
  })], 1), _vm._v(" "), (!_vm.SBDetail.cargoGrossWeight) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.errorSBExecution.cargoGrossWeight))]) : _vm._e()], 1)], 1), _vm._v(" "), _c('md-layout', {
    staticClass: "gutr",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "15"
    }
  }, [_c('label', [_vm._v("Carting Date")]), _vm._v(" "), _c('date-picker', {
    attrs: {
      "format": _vm.selectDateFormat,
      "lang": "en",
      "name": "cartingDate",
      "id": "cartingDate",
      "minute-step": 1
    },
    model: {
      value: (_vm.SBDetail.cartingDate),
      callback: function($$v) {
        _vm.$set(_vm.SBDetail, "cartingDate", $$v)
      },
      expression: "SBDetail.cartingDate"
    }
  })], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "40"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("CRN ( Carting Order)")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "name": "crnNumber",
      "id": "crnNumber"
    },
    model: {
      value: (_vm.SBDetail.crnNumber),
      callback: function($$v) {
        _vm.$set(_vm.SBDetail, "crnNumber", $$v)
      },
      expression: "SBDetail.crnNumber"
    }
  })], 1)], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "20"
    }
  }, [_c('b-button', {
    staticStyle: {
      "margin-top": "40px"
    },
    attrs: {
      "variant": "info",
      "size": "sm",
      "id": "addButtonLoaderSB"
    },
    on: {
      "click": _vm.addSBDetail
    }
  }, [_vm._v(_vm._s(_vm.SBDetail.shippingSBId == "" ? "Add " : "Edit") + " Shipping\n                        Bill")]), _vm._v(" "), _c('md-spinner', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "md-indeterminate": "",
      "id": "loaderSB"
    }
  })], 1)], 1)], 1) : _vm._e()]) : _vm._e()], 1), _vm._v(" "), (_vm.sbDetailArrayList.length > 0) ? _c('div', {
    staticClass: "mt-3"
  }, [_c('div', [_c('h5', [_c('b-badge', [_vm._v("Shipping Bill Details")])], 1)]), _vm._v(" "), _c('div', [_c('table', {
    staticClass: "table table-bordered",
    attrs: {
      "id": "SBDetailr"
    }
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Sr No.")]), _vm._v(" "), _c('th', [_vm._v("Shipper Invoice No")]), _vm._v(" "), _c('th', [_vm._v("Shipping Bill No")]), _vm._v(" "), _c('th', [_vm._v("Cargo Gross Weight")]), _vm._v(" "), _c('th', [_vm._v("Edit")]), _vm._v(" "), _c('th', [_vm._v("Delete")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.sbDetailArrayList), function(item, index) {
    return _c('tr', {
      key: index
    }, [_c('td', [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.shippingInvoiceNo))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.shippingBillNo))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.cargoGrossWeight))]), _vm._v(" "), _c('td', [_c('md-button', {
      staticClass: "md-icon-button md-raised md-dense",
      on: {
        "click": function($event) {
          _vm.viewEditSB(item.shippingSBId, index)
        }
      }
    }, [_c('md-icon', [_vm._v("edit")])], 1)], 1), _vm._v(" "), _c('td', [_c('md-button', {
      staticClass: "md-icon-button md-raised md-dense",
      on: {
        "click": function($event) {
          _vm.DeleteListSb(item.shippingSBId, index)
        }
      }
    }, [_c('md-icon', [_vm._v("delete_sweep")])], 1)], 1)])
  }))])])]) : _vm._e(), _vm._v(" "), _c('div', [(_vm.containerTypeDetailFactoryList.length > 0) ? _c('div', {
    staticClass: "mt-3"
  }, [_c('div', [_c('h5', [_c('b-badge', [_vm._v("Container Details")])], 1)]), _vm._v(" "), _c('div', [_c('table', {
    staticClass: "table table-bordered",
    attrs: {
      "id": "ffContainer"
    }
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Sr No.")]), _vm._v(" "), _c('th', [_vm._v("Container No.")]), _vm._v(" "), _c('th', [_vm._v("Container Type")]), _vm._v(" "), _c('th', [_vm._v("Custom Seal No.")]), _vm._v(" "), _c('th', [_vm._v("Line Seal No.")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.containerTypeDetailFactoryList), function(item, index) {
    return _c('tr', {
      key: index
    }, [_c('td', [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('td', {
      staticClass: "showMoreData",
      on: {
        "click": function($event) {
          _vm.viewEdit(item.ffExecutionContainerId, index)
        }
      }
    }, [_vm._v("\n                          " + _vm._s(item.containerNo) + "\n                        ")]), _vm._v(" "), _c('td', {
      staticClass: "showMoreData",
      on: {
        "click": function($event) {
          _vm.viewEdit(item.ffExecutionContainerId, index)
        }
      }
    }, [_vm._v("\n                          " + _vm._s(item.containerType) + "\n                        ")]), _vm._v(" "), _c('td', [_vm._v("\n                          " + _vm._s(item.customSealNo != "" ? item.customSealNo : "--") + "\n                        ")]), _vm._v(" "), _c('td', [_vm._v("\n                          " + _vm._s(item.LineSealNo != "" ? item.LineSealNo : "--") + "\n                        ")])])
  }))])])]) : _vm._e(), _vm._v(" "), (
    _vm.getContainerList.length > 0 ||
    _vm.ContainerTypeSizefactory.ffExecutionContainerId != ''
  ) ? _c('b-card', {
    staticClass: "mt-3",
    staticStyle: {
      "background": "whiteSmoke"
    }
  }, [(
    _vm.getContainerList.length > 0 ||
    _vm.ContainerTypeSizefactory.ffExecutionContainerId != ''
  ) ? _c('div', {
    staticClass: "gutr"
  }, [_c('md-layout', {
    staticClass: "labelMargtop",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "45"
    }
  }, [(_vm.ContainerTypeSizefactory.ffExecutionContainerId == '') ? _c('label', [_vm._v("Container Type/Size")]) : _vm._e(), _vm._v(" "), (_vm.ContainerTypeSizefactory.ffExecutionContainerId == '') ? _c('model-list-select', {
    attrs: {
      "option-value": "containerTypeId",
      "option-text": "containerType",
      "list": _vm.ContainerTypeList,
      "placeholder": "Select  Type/Size"
    },
    model: {
      value: (_vm.ContainerTypeSizefactory.containerTypeId),
      callback: function($$v) {
        _vm.$set(_vm.ContainerTypeSizefactory, "containerTypeId", $$v)
      },
      expression: "ContainerTypeSizefactory.containerTypeId"
    }
  }) : _c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', {
    attrs: {
      "for": "containerType"
    }
  }, [_vm._v("Container Type/Size")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "disabled": ""
    },
    model: {
      value: (_vm.ContainerTypeSizefactory.containerType),
      callback: function($$v) {
        _vm.$set(_vm.ContainerTypeSizefactory, "containerType", $$v)
      },
      expression: "ContainerTypeSizefactory.containerType"
    }
  })], 1), _vm._v(" "), (!_vm.ContainerTypeSizefactory.containerTypeId) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.errorContainer.containerTypeId))]) : _vm._e()], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "50"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("Container No.(eg. AAAA1234567) *")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "name": "containerNo"
    },
    on: {
      "keyup": _vm.containerNoRegexfun
    },
    model: {
      value: (_vm.ContainerTypeSizefactory.containerNo),
      callback: function($$v) {
        _vm.$set(_vm.ContainerTypeSizefactory, "containerNo", $$v)
      },
      expression: "ContainerTypeSizefactory.containerNo"
    }
  })], 1), _vm._v(" "), (!_vm.ContainerTypeSizefactory.containerNo) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.errorContainer.containerNo))]) : (_vm.containerNoRegexError != '') ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.containerNoRegexError))]) : _vm._e(), _vm._v(" "), (
    _vm.containerNoRegexError == '' &&
    _vm.ContainerTypeSizefactory.containerNo != '' &&
    _vm.ContainerTypeSizefactory.containerNo != _vm.algoConNo &&
    _vm.showAlgo == true
  ) ? _c('span', {
    staticClass: "error"
  }, [_vm._v("Note:System Generated Container No. is : " + _vm._s(_vm.algoConNo))]) : _vm._e()], 1)], 1), _vm._v(" "), _c('md-layout', {
    staticClass: "labelMargtop",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "50"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "15"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("Net Wgt.")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "netWeight",
      "name": "netWeight",
      "type": "number",
      "min": "0"
    },
    model: {
      value: (_vm.ContainerTypeSizefactory.netWeight),
      callback: function($$v) {
        _vm.$set(_vm.ContainerTypeSizefactory, "netWeight", $$v)
      },
      expression: "ContainerTypeSizefactory.netWeight"
    }
  })], 1)], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "10"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("Gross Wgt *")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "grossWeight",
      "name": "grossWeight",
      "type": "number",
      "min": "0"
    },
    model: {
      value: (_vm.ContainerTypeSizefactory.grossWeight),
      callback: function($$v) {
        _vm.$set(_vm.ContainerTypeSizefactory, "grossWeight", $$v)
      },
      expression: "ContainerTypeSizefactory.grossWeight"
    }
  })], 1), _vm._v(" "), (!_vm.ContainerTypeSizefactory.grossWeight) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.errorContainer.grossWeight))]) : _vm._e()], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "15"
    }
  }, [_c('label', {
    attrs: {
      "for": "weightUnit"
    }
  }, [_vm._v("Unit")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.unitList,
      "option-value": "uV",
      "option-text": "uT",
      "placeholder": "Select Unit",
      "name": "weightUnit",
      "id": "weightUnit"
    },
    model: {
      value: (_vm.ContainerTypeSizefactory.weightUnit),
      callback: function($$v) {
        _vm.$set(_vm.ContainerTypeSizefactory, "weightUnit", $$v)
      },
      expression: "ContainerTypeSizefactory.weightUnit"
    }
  })], 1)], 1), _vm._v(" "), _c('md-layout', {
    staticClass: "labelMargtop",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "15"
    }
  }, [_c('label', [_vm._v("Handover Date")]), _vm._v(" "), _c('date-picker', {
    attrs: {
      "format": _vm.selectDateFormat,
      "lang": "en",
      "minute-step": 1,
      "name": "handoverDate",
      "id": "handoverDate"
    },
    model: {
      value: (_vm.ContainerTypeSizefactory.handoverDate),
      callback: function($$v) {
        _vm.$set(_vm.ContainerTypeSizefactory, "handoverDate", $$v)
      },
      expression: "ContainerTypeSizefactory.handoverDate"
    }
  })], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "25"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("Custom Seal No.")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "customSealNo",
      "name": "customSealNo"
    },
    model: {
      value: (_vm.ContainerTypeSizefactory.customSealNo),
      callback: function($$v) {
        _vm.$set(_vm.ContainerTypeSizefactory, "customSealNo", $$v)
      },
      expression: "ContainerTypeSizefactory.customSealNo"
    }
  })], 1)], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "25"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("Line Seal No.")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "LineSealNo",
      "name": "LineSealNo"
    },
    model: {
      value: (_vm.ContainerTypeSizefactory.LineSealNo),
      callback: function($$v) {
        _vm.$set(_vm.ContainerTypeSizefactory, "LineSealNo", $$v)
      },
      expression: "ContainerTypeSizefactory.LineSealNo"
    }
  })], 1)], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "20"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("Container Tare Wgt")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "tareWeight",
      "name": "tareWeight",
      "type": "number",
      "min": "0"
    },
    model: {
      value: (_vm.ContainerTypeSizefactory.tareWeight),
      callback: function($$v) {
        _vm.$set(_vm.ContainerTypeSizefactory, "tareWeight", $$v)
      },
      expression: "ContainerTypeSizefactory.tareWeight"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('md-layout', {
    staticClass: "labelMargtop",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "15"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("Measurement (in CBM)")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "name": "noOfpkgUnit",
      "id": "noOfpkgUnit",
      "type": "number",
      "min": "0"
    },
    model: {
      value: (_vm.ContainerTypeSizefactory.measurement),
      callback: function($$v) {
        _vm.$set(_vm.ContainerTypeSizefactory, "measurement", $$v)
      },
      expression: "ContainerTypeSizefactory.measurement"
    }
  })], 1)], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "25"
    }
  }, [_c('label', [_vm._v("Package Details *")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.packageNameList,
      "id": "clientId",
      "option-value": "packageId",
      "option-text": "packageName",
      "placeholder": "Select  Package Name"
    },
    model: {
      value: (_vm.ContainerTypeSizefactory.packageId),
      callback: function($$v) {
        _vm.$set(_vm.ContainerTypeSizefactory, "packageId", $$v)
      },
      expression: "ContainerTypeSizefactory.packageId"
    }
  }), _vm._v(" "), (!_vm.ContainerTypeSizefactory.packageId) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.errorContainer.packageId))]) : _vm._e()], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "25"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("No. of Packages (" + _vm._s(_vm.ContainerTypeSizefactory.packageName) + ")\n                          *")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "name": "noOfpkgUnit",
      "id": "noOfpkgUnit",
      "type": "number",
      "min": "0",
      "disabled": _vm.ContainerTypeSizefactory.packageName == '' ? true : false
    },
    model: {
      value: (_vm.ContainerTypeSizefactory.noOfpkgUnit),
      callback: function($$v) {
        _vm.$set(_vm.ContainerTypeSizefactory, "noOfpkgUnit", $$v)
      },
      expression: "ContainerTypeSizefactory.noOfpkgUnit"
    }
  }), _vm._v(" "), (!_vm.ContainerTypeSizefactory.noOfpkgUnit) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.errorContainer.noOfpkgUnit))]) : _vm._e()], 1)], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "20"
    }
  }, [_c('label', [_vm._v("Cargo Stuffing Date")]), _vm._v(" "), _c('date-picker', {
    attrs: {
      "format": _vm.selectDateFormat,
      "lang": "en",
      "name": "cargoStuffingDate",
      "id": "cargoStuffingDate",
      "minute-step": 1
    },
    model: {
      value: (_vm.ContainerTypeSizefactory.cargoStuffingDate),
      callback: function($$v) {
        _vm.$set(_vm.ContainerTypeSizefactory, "cargoStuffingDate", $$v)
      },
      expression: "ContainerTypeSizefactory.cargoStuffingDate"
    }
  })], 1)], 1), _vm._v(" "), _c('md-layout', {
    staticClass: "labelMargtop",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "85"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "15"
    }
  }, [_c('b-button', {
    staticClass: "mt-2 pull-right",
    attrs: {
      "variant": "info",
      "size": "sm",
      "id": "addButtonLoaderfactory"
    },
    on: {
      "click": _vm.factoryStuffingContainer
    }
  }, [_vm._v(_vm._s(_vm.editIndex == "" &&
    (_vm.editIndex != 0 || _vm.editIndex != "0") &&
    _vm.ContainerTypeSizefactory.ffExecutionContainerId == "" ?
    "Add" :
    "Edit") + "\n                        Container")]), _vm._v(" "), _c('md-spinner', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "md-indeterminate": "",
      "id": "loaderfactory"
    }
  })], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.showDivCountNote) ? _c('md-layout', {
    staticStyle: {
      "margin-top": "1%"
    },
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "10"
    }
  }, [_c('label', [_c('b', [_c('u', {
    staticClass: "error"
  }, [_vm._v("Please Add")])])])]), _vm._v(" "), (_vm.containerCountWise.length > 0) ? _c('md-layout', {
    attrs: {
      "md-flex": "85"
    }
  }, _vm._l((_vm.containerCountWise), function(type1, index) {
    return _c('div', {
      key: index
    }, [(type1.totalCount != 0) ? _c('md-chip', {
      staticStyle: {
        "margin-right": "4px"
      }
    }, [(type1.totalCount != 0) ? _c('span', {
      staticStyle: {
        "color": "#0e0052"
      }
    }, [_vm._v(_vm._s(type1.containerType) + " -")]) : _vm._e(), _vm._v(" "), (type1.totalCount != 0) ? _c('span', {
      staticStyle: {
        "color": "red"
      }
    }, [_vm._v(_vm._s(type1.totalCount) + " Left")]) : _vm._e()]) : _vm._e()], 1)
  })) : _vm._e()], 1) : _vm._e()], 1) : _vm._e()], 1)]) : _vm._e(), _vm._v(" "), _c('div', [_c('md-layout', {
    staticClass: "labelMargtop",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "20"
    }
  }, [_c('label', [_vm._v("VGM Submission Date")]), _vm._v(" "), _c('date-picker', {
    attrs: {
      "format": _vm.selectDateFormat,
      "lang": "en",
      "name": "vgmSubmissionDate",
      "id": "vgmSubmissionDate",
      "minute-step": 1
    },
    model: {
      value: (_vm.WarehouseStuffing.vgmSubmissionDate),
      callback: function($$v) {
        _vm.$set(_vm.WarehouseStuffing, "vgmSubmissionDate", $$v)
      },
      expression: "WarehouseStuffing.vgmSubmissionDate"
    }
  })], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "20"
    }
  }, [_c('label', {
    attrs: {
      "for": "gateInDate"
    }
  }, [_vm._v("SI Submission date")]), _vm._v(" "), _c('date-picker', {
    attrs: {
      "lang": "en",
      "id": "gateInDate",
      "type": "datetime",
      "format": "YYYY-MM-DD hh:mm a",
      "minute-step": 1,
      "name": "gateInDate"
    },
    model: {
      value: (_vm.WarehouseStuffing.siSubmissionDate),
      callback: function($$v) {
        _vm.$set(_vm.WarehouseStuffing, "siSubmissionDate", $$v)
      },
      expression: "WarehouseStuffing.siSubmissionDate"
    }
  })], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "20"
    }
  }, [_c('label', {
    attrs: {
      "for": "trSubmissionDate"
    }
  }, [_vm._v("TR Submission date")]), _vm._v(" "), _c('date-picker', {
    attrs: {
      "lang": "en",
      "id": "trSubmissionDate",
      "type": "datetime",
      "format": "YYYY-MM-DD hh:mm a",
      "minute-step": 1,
      "name": "trSubmissionDate"
    },
    model: {
      value: (_vm.WarehouseStuffing.trSubmissionDate),
      callback: function($$v) {
        _vm.$set(_vm.WarehouseStuffing, "trSubmissionDate", $$v)
      },
      expression: "WarehouseStuffing.trSubmissionDate"
    }
  }), _vm._v(" "), (_vm.WarehouseStuffing.trSubmissionDate_err) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.WarehouseStuffing.trSubmissionDate_err))]) : _vm._e()], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "20"
    }
  }, [_c('label', [_vm._v("Handover Date")]), _vm._v(" "), _c('date-picker', {
    attrs: {
      "format": _vm.selectDateFormat,
      "lang": "en",
      "name": "handoverDate",
      "id": "handoverDate",
      "minute-step": 1
    },
    model: {
      value: (_vm.WarehouseStuffing.handoverDate),
      callback: function($$v) {
        _vm.$set(_vm.WarehouseStuffing, "handoverDate", $$v)
      },
      expression: "WarehouseStuffing.handoverDate"
    }
  }), _vm._v(" "), (_vm.WarehouseStuffing.handoverDate_err) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.WarehouseStuffing.handoverDate_err))]) : _vm._e()], 1)], 1), _vm._v(" "), _c('md-layout', {
    staticClass: "labelMargtop",
    attrs: {
      "md-gutter": ""
    }
  }), _vm._v(" "), (_vm.ffExportDetail.portType == 'Icd') ? _c('md-layout', {
    staticClass: "gutr",
    attrs: {
      "gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "25"
    }
  }, [_c('label', [_c('u', [_vm._v("Custom Clearance")])])])], 1) : _vm._e(), _vm._v(" "), (_vm.ffExportDetail.portType == 'Icd') ? _c('md-layout', {
    staticClass: "labelMargtop",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "20"
    }
  }, [_c('label', {
    attrs: {
      "for": "custmClearByPridel"
    }
  }, [_vm._v("CC to be done by Pridel")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.CCList,
      "option-value": "ccInfoVal",
      "option-text": "ccInfoText",
      "placeholder": "Select"
    },
    model: {
      value: (_vm.WarehouseStuffing.custmClearByPridel),
      callback: function($$v) {
        _vm.$set(_vm.WarehouseStuffing, "custmClearByPridel", $$v)
      },
      expression: "WarehouseStuffing.custmClearByPridel"
    }
  })], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "25"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("CC Assignment No.")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "name": "ccAsignmentNo",
      "id": "ccAsignmentNo"
    },
    model: {
      value: (_vm.WarehouseStuffing.ccAsignmentNo),
      callback: function($$v) {
        _vm.$set(_vm.WarehouseStuffing, "ccAsignmentNo", $$v)
      },
      expression: "WarehouseStuffing.ccAsignmentNo"
    }
  })], 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('div', [_c('b-button', {
    staticClass: "mt-3 smbutnWidth",
    attrs: {
      "variant": "primary",
      "id": "addButtonLoaderVGM"
    },
    on: {
      "click": function($event) {
        _vm.addFactoryExecution('SAVE')
      }
    }
  }, [_vm._v("Save & Submit")]), _vm._v(" "), _c('md-spinner', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "md-indeterminate": "",
      "id": "loaderVGM"
    }
  })], 1), _vm._v(" "), (
    (_vm.proceedFurther == true && _vm.sbDetailArrayList.length > 0) ||
    _vm.newContainerFlow == '1'
  ) ? _c('div', [(_vm.getContainerList.length == 0 || _vm.newContainerFlow == '1') ? _c('div', {
    attrs: {
      "md-gutter": ""
    }
  }, [_c('b-button', {
    staticClass: "mt-1",
    attrs: {
      "variant": "primary",
      "id": "addButtonLoaderVGM"
    },
    on: {
      "click": function($event) {
        _vm.addFactoryExecution('VGM')
      }
    }
  }, [_vm._v("Save & Proceed To VGM")]), _vm._v(" "), _c('md-spinner', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "md-indeterminate": "",
      "id": "loaderVGM"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.getContainerList.length == 0 || _vm.newContainerFlow == '1') ? _c('div', {
    attrs: {
      "md-gutter": ""
    }
  }, [_c('b-button', {
    staticClass: "mt-1",
    attrs: {
      "variant": "primary",
      "id": "addButtonLoaderVGM"
    },
    on: {
      "click": function($event) {
        _vm.addFactoryExecution('PAYTEST')
      }
    }
  }, [_vm._v("Save & Proceed To S-Line Payment")]), _vm._v(" "), _c('md-spinner', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "md-indeterminate": "",
      "id": "loaderVGM"
    }
  }), _vm._v(" "), _c('br')], 1) : _vm._e(), _vm._v(" "), (_vm.getContainerList.length == 0 || _vm.newContainerFlow == '1') ? _c('div', {
    attrs: {
      "md-gutter": ""
    }
  }, [((!_vm.ffExportDetail.mergeffExportId || _vm.ffExportDetail.mergeffExportId == '0')) ? _c('b-button', {
    staticClass: "mt-1",
    attrs: {
      "variant": "primary",
      "id": "addButtonLoaderBL"
    },
    on: {
      "click": function($event) {
        _vm.addFactoryExecution('BLRaised')
      }
    }
  }, [_vm._v("Save & Proceed to Raise B/L")]) : _vm._e(), _vm._v(" "), _c('md-spinner', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "md-indeterminate": "",
      "id": "loaderBL"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.getContainerList.length == 0 || _vm.newContainerFlow == '1') ? _c('div', {
    attrs: {
      "md-gutter": ""
    }
  }, [_c('b-button', {
    staticClass: "mt-1",
    attrs: {
      "variant": "primary",
      "id": "addButtonLoaderRail"
    },
    on: {
      "click": function($event) {
        _vm.addFactoryExecution('handover')
      }
    }
  }, [_vm._v(_vm._s(_vm.ffExportDetail.portType == "Icd" ?
    "Save & Proceed to Handover to Rail" :
    "Save & Proceed to Gate ­ in at Terminal By Road"))]), _vm._v(" "), _c('md-spinner', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "md-indeterminate": "",
      "id": "loaderRail"
    }
  })], 1) : _vm._e()]) : _vm._e()], 1)], 1)], 1)], 1)], 1), _vm._v(" "), (_vm.ALLMODULE) ? _c('div', [_c('b-modal', {
    ref: "doc-modal",
    staticClass: "modal-dialog-doc",
    attrs: {
      "size": "xl",
      "no-close-on-esc": "",
      "no-close-on-backdrop": "",
      "hide-footer": "",
      "title": ""
    }
  }, [_c('div', [_c('doc-form', {
    attrs: {
      "allModuleIdProp": _vm.ALLMODULE,
      "JOBSERIES": _vm.JOBSERIES
    }
  })], 1), _vm._v(" "), _c('b-button', {
    staticClass: "mt-3",
    attrs: {
      "variant": "outline-danger",
      "block": ""
    },
    on: {
      "click": _vm.hideDocModal
    }
  }, [_vm._v("Close\n      ")])], 1)], 1) : _vm._e(), _vm._v(" "), _c('md-dialog-confirm', {
    ref: "popMail",
    attrs: {
      "md-content-html": _vm.alert.content,
      "md-ok-text": _vm.alert.ok
    },
    on: {
      "close": _vm.sendMail
    }
  }), _vm._v(" "), _c('md-dialog-confirm', {
    ref: "popMailAfter",
    attrs: {
      "md-content-html": _vm.alert.content,
      "md-ok-text": _vm.alert.ok
    }
  }), _vm._v(" "), _c('md-dialog-confirm', {
    ref: "addPop6",
    attrs: {
      "md-content-html": _vm.alert.content,
      "md-ok-text": _vm.alert.ok
    },
    on: {
      "close": _vm.onClose6
    }
  }), _vm._v(" "), _c('md-dialog-confirm', {
    ref: "addPop7",
    attrs: {
      "md-content-html": _vm.alert.content,
      "md-ok-text": _vm.alert.ok
    },
    on: {
      "close": _vm.onClose7
    }
  }), _vm._v(" "), _c('md-dialog-confirm', {
    ref: "addPop",
    attrs: {
      "md-content-html": _vm.alert.content,
      "md-ok-text": _vm.alert.ok
    }
  }), _vm._v(" "), _c('md-dialog-confirm', {
    ref: "addPop2",
    attrs: {
      "md-content-html": _vm.alert.content,
      "md-ok-text": _vm.alert.ok
    },
    on: {
      "close": _vm.onClose
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3bde5e18","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/component/freightForwarding/ffExecutionWareHouse.vue
// module id = 2537
// module chunks = 0